var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout c:col-between-stretch"},[_c('div',{attrs:{"id":"layout-top-teleport"}}),_c('Topbar'),_c('div',{staticClass:"layout-main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }